import { render, staticRenderFns } from "./ContentTypeServices.vue?vue&type=template&id=c8407422&scoped=true&"
import script from "./ContentTypeServices.vue?vue&type=script&lang=js&"
export * from "./ContentTypeServices.vue?vue&type=script&lang=js&"
import style0 from "./ContentTypeServices.vue?vue&type=style&index=0&id=c8407422&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8407422",
  null
  
)

export default component.exports